import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useRedditAuth } from './RedditAuthContext';

export default function RedditProtectedRoute({
  children,
  adminOnly = false,
}) {
  const { user, loading } = useRedditAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="rh-loading-screen">
        <div className="rh-loading-dot" />
        <span>Loading…</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/reddit/login" state={{ from: location.pathname }} replace />;
  }

  // Accountants get the admin dashboard (limited sidebar)
  if (adminOnly && !user.is_admin && !user.is_accountant) {
    return <Navigate to="/reddit/dashboard" replace />;
  }

  return children;
}
